<template>
	<div>
		<vs-prompt
			:active.sync="activeProp"
			:buttons-hidden="true"
			:title="$t('addTag')"
			:cancel-text="$t('cancel')"
			button-cancel="filled"
			color="warning"
			class="marginality-popup"
			@cancel="close"
			@close="close"
		>
			<div class="con-exemple-prompt">

				<div class="mt-2">

					<v-select
						v-model="selectedTags"
						name="tags"
						label="name"
						:options="localizedTags"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
            :placeholder="$t('selectTags')"
						multiple
					/>

					<div class="flex justify-end">
						<vs-button
							color="success"
							@click="saveTags"
							:disabled="loading"
							class="my-4"
						>
							<template>
								{{ $t('save') }}
							</template>
						</vs-button>
					</div>

				</div>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import vSelect from 'vue-select';
import databaseManager from "@/mixins/databaseManager";

export default {
	name: "FileTagPopUp",
	props: {
		active: { default: false, type: Boolean },
		model: { type: Object },
		tags: { type: Array },
		file: {
			type: null,
			required: true
		},
		fileTags: {
			type: Object,
			required: true
		}
	},
	components: {
		vSelect
	},
	mixins: [databaseManager],
	data() {
		return {
			selectedTags: [],
			loading: false,
			currentLanguage: localStorage.getItem('locale'),
		};
	},
	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		},
		localizedTags() {
			return this.tags.map(tag => ({
				...tag,
				name: this.getLocalizedTagName(tag)
			}));
		}
	},
	watch: {
		tags: {
			immediate: true,
			handler() {
				this.$nextTick(() => {
					this.setSelectedTags();
				});
			}
		},
		fileTags: {
			deep: true,
			handler() {
				this.$nextTick(() => {
					this.setSelectedTags();
				});
			}
		},
		file() {
			this.$nextTick(() => {
				this.setSelectedTags();
			});
		},
		model: {
			handler(newValue) {
				this.initOrder(newValue);
			},
			deep: true,
		},
	},

	methods: {
		close() {
			this.activeProp = false;
			this.$emit("cancel");
		},
		getLocalizedTagName(tag) {
			const key = `name_${this.currentLanguage}`;
			return tag[key] || tag.name_en || "No name";
		},
		setSelectedTags() {
			if (this.file && this.fileTags && this.fileTags[this.file.id]) {
				const fileTagIds = this.fileTags[this.file.id].map(tag => Number(tag.id));
				this.selectedTags = this.localizedTags.filter(tag => fileTagIds.includes(Number(tag.id)));
			}
		},
		async saveTags() {
			const data = {
				order_file_id: this.file.id,
				tag_ids: this.selectedTags.map(tag => tag.id)
			};
			this.loading = true;

			try {
				await this.dbAddTagToFile(data);
				this.notifySuccess(this.$t('success'));

			} catch (e) {
				this.notifyError(e.message);
			} finally {
        this.$emit("updateModel");
				this.loading = false;
				this.close();

			}
		}
	},
};
</script>


<style lang="scss">
.marginality-popup {
	&.con-vs-dialog {
		z-index: 54000;
	}
	.vs-dialog {
		max-width: 350px;
	}
}
</style>
